import { Component, Input, Output, EventEmitter,OnInit } from '@angular/core';

@Component({
  selector: 'core-helpers-icons-notes-counter-bubble',
  templateUrl: './notes-counter-bubble.component.html',
  styleUrls: ['./notes-counter-bubble.component.scss'],
})
export class IconsNotesCounterBubbleComponent implements OnInit {

  @Input() title: string = '';
  @Input() letter: string = '';
  @Output() actionClick = new EventEmitter<any>();



  constructor() { }

  ngOnInit(){
    if (this.letter == '' && this.title != ''){
      this.letter = this.title.charAt(0).toUpperCase();
    }
  }

  onBubbleClick(event: any) {
      // console.log(" bubble notes item click",this.title,this.letter)
      this.actionClick.emit();
  }


}
